export default {
    install: function (Vue) {
        //验证是否手机号 mobile
        Vue.prototype.isMobile = function (obj) {
            let reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
            if (!reg.test(obj)) {
                return false;
            } else {
                return true;
            }
        }
        //判断登录密码格式
        Vue.prototype.isPwd = function (str) {
            var patrn = /^[A-Za-z0-9\u4e00-\u9fa5-\~\!\@\#\$\%\^\&\*\(\)\+\-\=\{\}\[\]\|\<\>\?._,]{6,20}$/;
            if (!patrn.exec(str)) return false;
            return true;
        }
        // 获取日期 formatDate
        Vue.prototype.formatDate = function (date) {
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y + '-' + m + '-' + d;
        };
        // 倒计时
        Vue.prototype.countTime = function (inputTime) {
            //获取当前时间  
            var now = Date.now();
            //设置截止时间  
            var end = new Date(inputTime).getTime();
            //时间差  
            var leftTime = now - end;
            //定义变量 d,h,m,s保存倒计时的时间  
            var d, h, m, s;
            if (leftTime >= 0) {
                d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
                h = Math.floor(leftTime / 1000 / 60 / 60);
                m = Math.floor(leftTime / 1000 / 60 % 60);
                s = Math.floor(leftTime / 1000 % 60);
            }
            d <= 9 ? d = '0' + d : d = d;
            h <= 9 ? h = '0' + h : h = h;
            m <= 9 ? m = '0' + m : m = m;
            s <= 9 ? s = '0' + s : s = s;
            //将倒计时赋值到div中  
            return { 'd': d, 'h': h, 'm': m, 's': s }
        }
        //显示手机未4位
        Vue.prototype.sliceMobile = function (mobile) {
            var result = '';
            if (mobile == null || mobile.length == 0 || mobile == undefined) {
                result = '--';
            } else {
                result = mobile.substr(-4, 4);
            }
            return result;
        }
        // 判断非空
        Vue.prototype.isNull = function (arr) {
            for (var i = 0; i < arr[0].length; i++) {
                if (!arr[0][i] && arr[0][i].trim() == '') {
                    return arr[1][i] //false
                }
            }
            return true
        }
        //验证两个值是否相等 equals 
        Vue.prototype.isEqual = function (str1, str2) {
            return str1 == str2 ? true : false;
        }
        // 判断邮箱
        Vue.prototype.isEmail = function (obj) {
            var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            if (!reg.test(obj)) {
                return false;
            } else {
                return true;
            }
        }
        //  函数防抖动
        Vue.prototype.fangDou = function (fn, t) {
            let delay = t || 500;
            let timer;
            return function () {
                let args = arguments;
                if (timer) {
                    clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    timer = null;
                    fn.apply(this, args);
                }, delay);
            }
        }





    }
}



// export function isBank(obj) {
//     var reg = /^(\d{12,20})$/;
//     if (!reg.test(obj)) {
//         return false;
//     } else {
//         return true;
//     }
// }
// export function regNum(Num) {
//     var regIdNo = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
//     if (!regIdNo.test(Num)) {
//         return false;
//     } else {
//         return true;
//     }
// }